<template>
  <div class="global-login-mask" v-show="visible">
    <div class="global-login">
      <div class="wrap">
        <div class="close" @click="visible = false"></div>
        <div class="login-panel">
          <a :href="login_activity_url">
            <img :src="login_activity_img" class="login-adv" />
          </a>
        </div>
        <div class="login-panel">
          <div class="login-panel-box">
            <BoxLogin @sendLogin="getLogin"></BoxLogin>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoxLogin from "../BoxLogin";
export default {
  components: { BoxLogin },
  data() {
    return {
      visible: false,
      isLogin: this.$.user.userLogin(),
      login_activity_img: "",
      login_activity_url: "https://china.mro365.com/register", //默认跳转注册页，可在后台配置成活动地址
    };
  },
  methods: {
    openDialogTasker() {
      const { isLogin } = this;
      if (isLogin) {
        this.visible = false;
      } else {
        setTimeout(() => {
          this.visible = true;
        }, 1000 * 60 * 3);
      }
    },
    setLoginBanner() {
      this.$.http.get("getLoginActivity", "").then((res) => {
        if (res.code == 200) {
          const { login_activity_img, login_activity_url } = res.data;
          this.login_activity_img = login_activity_img;
          this.login_activity_url = login_activity_url;
        }
      });
    },
    getLogin(val){
        this.isLogin = val || false
        this.openDialogTasker()
    }
  },
  mounted() {
    this.setLoginBanner();
    this.openDialogTasker();
  }
};
</script>

<style scoped>
.global-login-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.45);
  -webkit-box-shadow: 0 -1px 0 0 rgb(0 0 0 / 10%);
  box-shadow: 0 -1px 0 0 rgb(0 0 0 / 10%);
}
.global-login {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-perspective: 1000;
  perspective: 1000;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 720px;
  height: 450px;
  margin-left: -360px;
  margin-top: -225px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}
.global-login .login-panel {
  width: 50%;
  height: 450px;
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.global-login .login-adv {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.global-login .close {
  position: absolute;
  top: 18px;
  right: 20px;
  width: 24px;
  height: 24px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAKlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKE86IAAAADnRSTlMA1+eN8eHSpRJqiIcIadDXG2gAAACOSURBVDjLYxjpoBPBnIEszlNiAGMyux9AkmhXU4YxjZIqkCSuJAoZQDUoinmCGTCuoDJUgyBMCYKPUIGmBVMDTAQmj6EFJo2pBSKLqUV7EVgDphbRQIgGTC1gDZhgq6BgNNYQXiooGMVA0CjCliOcS9CDmEFCMBAxgx1PRBGO2ikoiYFQ8sFMcDiT6AgHAJH+H0YCgqsBAAAAAElFTkSuQmCC)
    no-repeat center;
  background-size: 24px 24px;
  cursor: pointer;
}
.login-panel-box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/DialogLogin/index.vue